// icons
import { MdOutlinePrecisionManufacturing, MdAssignment } from "react-icons/md";

const ordenesProduccion = {
  id: 'ordenes-produccion-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'ordenes-produccion',
      title: 'Órdenes de producción',
      type: 'item',
      breadcrumbs: false,
      icon: MdAssignment,
      url: '/ordenes-produccion'
    }
  ]
};

const areaProduccion = {
  id: 'area-produccion-tablero-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'area-produccion-tablero',
      title: 'Área de producción',
      type: 'item',
      breadcrumbs: false,
      icon: MdOutlinePrecisionManufacturing,
      url: '/area-produccion'
    }
  ]
};

export default [ordenesProduccion, areaProduccion];
